import Identificacion from "../Comun/Identificacion";

export default class ParametroDetalleSolicitud{
  
    constructor(){
        this.Consecutivo = 0;
        this.IdPersonaTramite = new Identificacion();
    }

     Consecutivo:number;
     IdPersonaTramite: Identificacion;

}